<template lang="pug">
include /mixins
+b.trip-monthly-distribution-wrap
  chart(
    :chart-data='chartData'
    :options='chartOptions',
  )
  div(id="custom-tooltip" class="custom-tooltip-label" style="opacity: 0")

</template>

<script>

import {
  mapState, mapActions,
} from 'vuex'

import pathOr from 'ramda/src/pathOr'
import { COLORS } from '@app/Trips/const'

const chart = () => import('@app/Trips/Bar.vue')

const CURRENT_MONTH_STATUS = 'current'
const PAST_MONTH_STATUS = 'past'

const ZERO = 0

export default {
  props: {
    trip_label: {
      type: String,
      required: true,
    },
    path: {
      type: Array,
      required: true,
    },
  },
  components: {
    chart,
  },
  data() {
    return {
      CURRENT_MONTH_STATUS,
      PAST_MONTH_STATUS,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: { drawOnChartArea: false },
          }],
          yAxes: [{
            id: 'y-axis-0',
            stacked: true,
            gridLines: {
              display: true,
              drawTicks: true,
            },
            ticks: {
              beginAtZero: true,
              callback: value => `${value} ${window.currency}`,
              display: true,
            },
          }],
        },
        legend: { display: false },
        tooltips: {
          mode: 'index',
          intersect: false,
          enabled: false,
          custom(tooltipModel) {
            const tooltipEl = document.getElementById('custom-tooltip');
            if (!tooltipEl) return;

            if (0 === tooltipModel.opacity) {
              tooltipEl.style.opacity = 0;
              return;
            }

            tooltipEl.innerHTML = '';

            if (tooltipModel.body && tooltipModel.body.length) {
              const table = document.createElement('table');
              table.style.margin = '0';

              tooltipModel.body.forEach((bodyItem, i) => {
                const color = tooltipModel.labelColors[i];
                const value = bodyItem.lines[0];

                const tr = document.createElement('tr');

                const tdColor = document.createElement('td');
                tdColor.style.width = '12px';
                tdColor.style.paddingRight = '6px';
                tdColor.innerHTML = `<span style="
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: ${color.backgroundColor};
                  border: 1px solid ${color.borderColor};
                  border-radius: 50%;
                  margin-right: 4px;
                  vertical-align: middle;
                "></span>`;

                const tdText = document.createElement('td');
                tdText.style.color = '#fff';
                tdText.style.fontSize = '12px';
                tdText.innerText = value;

                tr.appendChild(tdColor);
                tr.appendChild(tdText);
                table.appendChild(tr);
              });

              tooltipEl.appendChild(table);
            }

            const canvasRect = this._chart.canvas.getBoundingClientRect();
            const tooltipWidth = tooltipEl.offsetWidth;
            const tooltipHeight = tooltipEl.offsetHeight;

            let left = canvasRect.left + window.pageXOffset + tooltipModel.caretX;
            let top = canvasRect.top + window.pageYOffset + tooltipModel.caretY - tooltipHeight - 10;

            const maxLeft = window.innerWidth - tooltipWidth - 10;
            if (left > maxLeft) left = maxLeft;

            if (10 > left) left = 10;

            if (10 > top) {
              top = canvasRect.top + window.pageYOffset + tooltipModel.caretY + 10;
            }
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.left = `${left}px`;
            tooltipEl.style.top = `${top}px`;
          },
        },
        plugins: {
          datalabels: {
            display: 'auto',
            anchor: 'end',
            align: 'end',
            color: '#000',
            font: {
              size: 12,
            },
            formatter(value, context) {
              const { datasetIndex } = context
              const index = context.dataIndex
              const { chart } = context
              const total = chart.data.datasets
                .map(ds => ds.data[index] || 0)
                .reduce((a, b) => a + b, 0)
              return `${Math.floor(total)} ${window.currency}`
            },
          },
        },
        annotation: {
          annotations: [
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 30,
              borderColor: '#FBD670',
              borderWidth: 2,
              borderDash: [6, 4],
              label: {
                enabled: true,
                content: '30€',
                backgroundColor: '#FBD670',
                fontColor: '#000',
                position: 'right',
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    ...mapState('trip', ['trip']),
    list() {
      return pathOr({}, this.path, this.trip)
    },
    chartData() {
      if (!this.trip.conditions || !this.trip.conditions.length) return null
      const [first] = this.trip.conditions
      const data = this.trip.conditions.reduce((acc, item) => {
        acc.datasets.push({
          label: item.props.condition_name_for_sso,
          backgroundColor: COLORS[acc.datasets.length % COLORS.length],
          data: item.props.monthly_distribution.map(e => e.monthly_sale),
          stack: 'total',
        })
        return acc
      }, {
        labels: first.props.monthly_distribution.map((e, i) => `${i + 1} ${this._('мес.')} \n ${(2 === e.month.toString().length ? e.month : `0${e.month}`)}.${e.year}`),
        datasets: [],
      })
      return data
    },
  },
  // mounted() {
  //   this.getTrip(this.trip_label)
  // },
  watch: {
    trip: {
      handler() {
        if (!this.trip.trip_potential_participant) return null
        const [first] = this.trip.trip_potential_participant.props.monthly_distribution
        if (!first) return null
        this.chartOptions.annotation.annotations[0].value = first.monthly_purchase
        this.chartOptions.annotation.annotations[0].label.content = `${Math.floor(first.monthly_purchase)}${window.currency}`
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions('trip', ['getTrip']),
    getPercent(value, from) {
      return Math.round((value / from) * 100)
    },
  },
}

</script>
